import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaderService} from './http-header.service';
import {HttpClient} from '@angular/common/http';
import {APP_CONFIG} from '../config/app-config.token';
import {AppConfig} from '../config/app-config.model';
import {AtosJwt} from '../model/atosJwt';
import {CapacitorHttpService} from './capacitor-http.service';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private http = inject(HttpClient);
  private capacitorHttp = inject(CapacitorHttpService);
  private httpHeaderService = inject(HttpHeaderService);
  private config = inject<AppConfig>(APP_CONFIG);

  baseurl: string;

  constructor() {
    this.baseurl = this.config.apiGatewayUrl;
  }

  getToken(ssin: string, fgtbref: string, documentType: string): Observable<AtosJwt> {
    return this.capacitorHttp.get<AtosJwt>(
      this.baseurl + `/members/${ssin}/token/${fgtbref}?documentType=${documentType}`,
      this.httpHeaderService.getHeaderOptions());
  }

  // ========== METHODS FOR EXTERNAL USERS (using /me endpoints) ==========
  // These methods are for external users (members) who can only access their own data.
  // Tyk API Gateway rewrites /members/me to /members/{jwt.preferred_username}

  /**
   * Get token for authenticated external user
   * @param fgtbref FGTB reference
   * @param documentType Document type
   * @returns Observable<AtosJwt>
   */
  getMyToken(fgtbref: string, documentType: string): Observable<AtosJwt> {
    return this.capacitorHttp.get<AtosJwt>(
      this.baseurl + `/members/me/token/${fgtbref}?documentType=${documentType}`,
      this.httpHeaderService.getHeaderOptions()
    );
  }

}
